<template>
    <mc-modal
        v-model="show"
        append-to-body
        width="600px"
        class="schedule-dlg"
    >
        <template slot="title">
            <div class="dlg-title">
                AI卖点
            </div>
        </template>
        <mc-loading
            :loading="loading"
            :message="loadingText"
            class="container"
        >
            <div>
                <div>当前生成卖点：</div>
                <div v-if="sellPoints.length === 0">
                    暂未生成卖点，请点击重新生成
                </div>
                <template v-else>
                    <mc-tooltip
                        v-for="item in sellPoints"
                        :key="item.point"
                        placement="top"
                    >
                        <mc-button
                            class="btn"
                            type="primary"
                            size="small"
                            icon="mtdicon mtdicon-add"
                            @click="add(item.point)"
                        >
                            {{ item.point }}
                        </mc-button>

                        <div
                            slot="content"
                            name="content"
                        >
                            <div>
                                卖点描述： {{ item.pointDescription }}
                            </div>
                            <div>
                                卖点来源： {{ item.reference }}
                            </div>
                        </div>
                    </mc-tooltip>
                </template>
            </div>
            <div>
                <div>选中卖点：</div>
                <div v-if="selectedSellPoints.length === 0">
                    当前未选中卖点
                </div>
                <template v-else>
                    <mc-button
                        v-for="text in selectedSellPoints"
                        :key="text"
                        class="btn"
                        type="primary"
                        size="small"
                        icon="mtdicon mtdicon-close"
                        @click="remove(text)"
                    >
                        {{ text }}
                    </mc-button>
                </template>
            </div>
        </mc-loading>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <mc-button
                :disabled="loading"
                class="btn"
                type="primary"
                plain
                @click="cancel"
            >
                取消
            </mc-button>
            <mc-button
                :disabled="loading"
                class="btn"
                type="primary"
                @click="reGenerate"
            >
                重新生成
            </mc-button>
            <mc-button
                :disabled="loading"
                type="primary"
                @click="submit"
            >
                添加
            </mc-button>
        </div>
    </mc-modal>
</template>

<script>
import { reportLx, fetchPortal } from '@lsfe/tools';
import { getCookie } from '@mcfe/tools';

const AISELLPOINTTYPEENUM = 103;

export default {
    name: 'AiSellPointDlg',
    components: {},
    props: {
        isCreateNewRefer: {
            type: Boolean,
            default: false,
        },
        createNewReferData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            show: false,
            loading: false,
            sellPoints: [],
            selectedSellPoints: [],
            loadingText: '数据加载中，请勿关闭',

            reviewList: [],
            infoData: {},
            pointConfig: {},
        };
    },
    computed: {
        isGreaterThan() {
            return Math.random() > 0.5;
        },
    },
    methods: {
        async popup(skuBaseId, levelTwoCategory) {
            this.loading = true;
            this.show = true;
            try {
                await this.init(skuBaseId, levelTwoCategory);
                reportLx('moduleClick', 'b_chaoshi_9dxvzhu8_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_6sxvv1ka' }); // 埋点
            } finally { this.loading = false; }
        },
        // 处理参数
        handleParam(infoData) {
            const {
                bgCategoryName, brandName, name, skuName, spuBaseId, skuId,
                skuSellPointContentList, specActual, skuExtAttrList,
            } = infoData;
            const { sellPointBlack, categoryAdvice } = this.pointConfig;
            const params = {
                skuId,
                spuId: spuBaseId,
                skuName: name || skuName,
                specActual,
                bgCategoryName,
                sellPoints: (skuSellPointContentList || []).map((item) => item.sellPointContentName).join(),
                comments: this.reviewList.join(),
                attrInfo: (skuExtAttrList || []).map((item) => ({
                    attrName: item.attrName,
                    value: (item.selectedValues || []).map((valueItem) => valueItem.value).join(),
                })),
                brandName,
                cleanComments: true,
                categoryAdvice: categoryAdvice || '',
                sellPointBlack: sellPointBlack || '',
                modelName: this.isGreaterThan ? 'claude35SonnetV2' : 'gpt4oMini',
            };
            return params;
        },

        // 请求卖点
        async queryAISellPoints() {
            this.loading = true;
            try {
                const headers = { Authorization: 'Bearer 3f0a07b1c2d6f9b577e3a3f958e498471a9382001de7e0a84bbf0d438fc126d6' };
                const AISellPoints = await this.$hPost('/api/mc/gpt/sku/point', this.handleParam(this.infoData), { headers });
                reportLx('moduleClick', 'b_chaoshi_fz1sksx2_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_hnd3fv8y' });
                this.sellPoints = AISellPoints.sellingPoints;
            } catch (e) {
                this.generate();
            } finally {
                this.loading = false;
            }
        },

        // 初始化商品信息
        async init(skuId, levelTwoCategory) {
            const fetchReviewList = async () => {
                const params = {
                    skuId,
                    offset: 0,
                    limit: 30,
                    labelCode: 0,
                };
                const reviewList = await this.$hGet('/api/m/mallorder/review/querySkuReviewList', params).catch(() => ({}));
                return reviewList;
            };
            const fetchPointConfig = async () => {
                const pointConfig = await fetchPortal('mall_nest_gpt_config')('sku_point_config');
                return pointConfig;
            };
            const fetchProductInfo = async () => {
                const params = { data: { skuBaseIdList: [skuId] } };
                const infoData = await this.$hPost('/api/vss/shepherd/ProductSearchTService/mapSpuBaseBySkuId', params);
                return infoData;
            };
            const [reviewList, pointConfig, infoData] = await Promise.all([
                fetchReviewList(),
                fetchPointConfig(),
                fetchProductInfo(),
            ]);
            this.reviewList = (reviewList?.reviewList || []).map((item) => item.reviewBody).filter(Boolean);
            this.pointConfig = pointConfig?.[levelTwoCategory] || {};
            this.infoData = this.isCreateNewRefer ? { ...this.createNewReferData, skuId } : { ...infoData?.spuBaseMap[skuId], ...infoData?.spuBaseMap?.[skuId]?.skuBaseList?.[0], skuId };
            this.loadingText = 'AI商品卖点正在生成中...';
            await this.queryAISellPoints();
        },

        // 重新生成商品卖点(该方法用于重新生成商品卖点，并更新商品卖点数据)
        async generate() {
            this.loadingText = 'AI商品卖点发生幻觉，正在重新生成中...'; // 设置加载提示文本
            await this.queryAISellPoints();
        },

        // 重新生成商品卖点
        async reGenerate() {
            this.loadingText = 'AI商品卖点重新生成中...'; // 设置加载提示文本
            await this.queryAISellPoints();
        },

        /**
         * 添加选中的卖点
         * @param {string} sellPoint - 要添加的卖点
         */
        add(sellPoint) {
            if (this.selectedSellPoints.includes(sellPoint)) {
                this.$mc.message.warning(`卖点【${sellPoint}】已经被选中过。`);
            } else {
                if (this.isGreaterThan) {
                    reportLx('moduleClick', 'b_chaoshi_yitk0q5g_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_hnd3fv8y' });
                } else {
                    reportLx('moduleClick', 'b_chaoshi_fbyyz7fq_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_hnd3fv8y' });
                }
                this.selectedSellPoints.push(sellPoint);
            }
        },

        /**
        * 移除选中的卖点
        * @param {string} sellPoint - 要移除的卖点
        */
        remove(sellPoint) {
            const selectedIndex = this.selectedSellPoints.indexOf(sellPoint);
            this.selectedSellPoints.splice(selectedIndex, 1);
        },
        /**
         * 查询卖点是否存在
         * @param {string} sellPointContentName - 卖点内容名称
         * @returns {boolean} - 返回卖点是否存在的结果，存在返回true，不存在返回false
         */
        async querySellPointExist(sellPointContentName) {
            const { resultList = [] } = await this.$hPost(
                '/api/vss/shepherd/product/searchSellPointAllList',
                {
                    sellPointContentName,
                    sellPointTypeId: -1,
                    paging: {
                        offset: 0,
                        limit: 20,
                    },
                },
            );
            return resultList.length !== 0 && resultList.find((item) => item.sellPointContentName === sellPointContentName);
        },

        /**
        * 添加卖点
        * @param {string} sellPointContentName - 卖点内容名称
        * @returns {Object} - 返回添加卖点的结果
        */
        async addSellPoint(sellPointContentName) {
            const res = await this.$hPost(
                '/api/vss/shepherd/productapi/sellpoint/addSellPointContent',
                {
                    sellPointContentId: -1,
                    sellPointContentName,
                    sellPointTypeId: AISELLPOINTTYPEENUM,
                    operator: getCookie('msid'),
                },
            );
            return res;
        },

        // 关闭
        cancel() {
            this.show = false;
            reportLx('moduleClick', 'b_chaoshi_wiugzd6d_mc', { msid: getCookie('msid') }, { cid: 'c_chaoshi_6sxvv1ka' });
        },

        async submit() {
            if (!this.selectedSellPoints.length) {
                this.$mc.message.warning('未选择卖点');
                return;
            }

            try {
                const sellPointItems = [];
                await Promise.all((this.selectedSellPoints || []).map(async (sellPointContentName) => {
                    const sellPointItem = await this.querySellPointExist(sellPointContentName);
                    if (!sellPointItem) {
                        const res = await this.addSellPoint(sellPointContentName);
                        sellPointItems.push({
                            sellPointContentId: res.sellPointContentId,
                            sellPointContentName: res.sellPointContentName,
                            sellPointTypeName: res.sellPointTypeName,
                            sellPointTypeId: res.sellPointTypeId,
                        });
                    }
                    sellPointItems.push(sellPointItem);
                }));
                this.$emit('add', sellPointItems);
                await this.$message.success('AI卖点添加成功');
                reportLx('moduleClick', 'b_chaoshi_nr52vi61_mc', {
                    sellpoint: sellPointItems.map((item) => item.sellPointContentName).join(','),
                    count: sellPointItems.length,
                    msid: getCookie('msid'),
                }, { cid: 'c_chaoshi_6sxvv1ka' });
                this.selectedSellPoints = [];
                this.show = false;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style scoped lang="scss">
.schedule-dlg {
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    margin-right: 4px;
    margin-bottom: 4px;
  }
  /deep/ .el-dialog {
    margin: auto !important;
  }
  /deep/ .el-dialog__header {
    background-color: #ffffff;
    height: auto;
    .dlg-title {
      display: flex;
      font-size: 18px;
      color: #292929;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 500;
      padding: 24px;
    }
    .el-icon-close {
      font-size: 15px;
      color: #000000;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0 12px;
  }
  /deep/ .el-dialog__footer {
    background-color: #ffffff;
  }
  .container {
    min-height: 100px;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
